var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('f-row',{ref:"wrapper",staticClass:"wrapper",style:({
      transform: `translateX(-${_vm.currentIndex * (_vm.swiperItemWidth + _vm.gap)}px)`,
    })},[_vm._t("default")],2),_c('f-row',{staticClass:"control-wrapper",attrs:{"justify":"space-between","aligner":"middle"}},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-slider",style:({
          width: `${_vm.sliderWidth}px`,
          transform: `translateX(${_vm.currentIndex * _vm.sliderWidth}px)`,
        })})]),_c('div',{staticClass:"page-turn-button"},[_c('img',{class:['pre', 'page-btn', _vm.currentIndex === 0 ? 'disabled' : ''],attrs:{"src":require("@/assets/images/design-arrow.webp"),"alt":""},on:{"click":_vm.pre}}),_c('img',{class:[
          'next',
          'page-btn',
          _vm.currentIndex === _vm.c_total - 1 ? 'disabled' : '',
        ],attrs:{"src":require("@/assets/images/design-arrow.webp"),"alt":""},on:{"click":_vm.next}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }